import useApi from '../utils/axios-pettitions';
import { useAppDispatch } from '../contexts/hooks';
import { newToast } from '../components';
import { EReportId } from '../types/types.dashboard';
import { setDashboards, setLoading, updateDashboardData } from '../contexts/slices/dashboards';


export const useApiDashBoard = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();

  //Obtener datos
  const getData = async (idDashboard: EReportId) => {
    dispatch(setLoading(idDashboard));
    return runApi('DashBoard/GetData', 'GET', { idDashboard }).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        dispatch(updateDashboardData({ id: idDashboard, data: res.data }));        
      }
    });
  };

  // Obtener la configuración de los dashboards
  const getConfigDb = async () => {
    return runApi('DashBoard/GetConfig', 'GET').then(async (res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        // Dispatch para configurar los dashboards
        dispatch(setDashboards(res.data));
      }
    });
  };

  return { getData, getConfigDb };
};
